import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Input,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import {
  setSelectedFiles,
  setSelectedAllFiles,
} from '../../actions/Files';

const FilesSelectAll = ({
  files,
  filesTotal,
  selectedFiles,
  selectVisibleFiles,
  selectedAllFiles,
  share,
  selectAllFiles,
  unselectAllFiles,
}) => {
  const intl = useIntl();

  const loadedFiles = files.length;
  const isSelectAllChecked = loadedFiles > 0 && loadedFiles === selectedFiles.length;
  const showSelectAll = filesTotal > loadedFiles;

  if (loadedFiles === 0) {
    return null;
  }

  return (
    <div className="list-select select-all-files">
      {share ? (
        <>
          <label htmlFor="FilesSelectAll" id="FilesSelectAllLabel">
            {intl.formatMessage({
              defaultMessage: 'Select {loadedFiles} {loadedFiles, plural, one {file} other {files}}',
            }, { loadedFiles })}
          </label>
          <div className="checkbox-wrapper">
            <Input
              type="checkbox"
              className="input-check check-l"
              id="FilesSelectAll"
              checked={isSelectAllChecked}
              onChange={() => {
                if (isSelectAllChecked) {
                  unselectAllFiles();
                } else {
                  selectVisibleFiles(files);
                  selectAllFiles(false);
                }
              }}
            />
          </div>
        </>
      ) : (
        <>
          <label htmlFor="FilesSelectAll">
            {intl.formatMessage({ defaultMessage: 'Select files' })}
          </label>
          <UncontrolledButtonDropdown>
            <DropdownToggle id="FilesSelectAll" caret size="sm" color="secondary" className="select-all-button" />
            <DropdownMenu>
              <DropdownItem
                onClick={() => {
                  if (isSelectAllChecked && !selectedAllFiles) {
                    unselectAllFiles();
                  } else {
                    selectVisibleFiles(files);
                    selectAllFiles(false);
                  }
                }}
              >
                {(isSelectAllChecked && !selectedAllFiles) && (
                  <i className="far fa-check" />
                )}
                {intl.formatMessage({ defaultMessage: 'Select visible {files}' }, { files: loadedFiles })}
              </DropdownItem>
              {showSelectAll && (
                <DropdownItem
                  onClick={() => {
                    if (selectedAllFiles) {
                      unselectAllFiles();
                    } else {
                      selectAllFiles(true);
                      selectVisibleFiles(files);
                    }
                  }}
                >
                  {selectedAllFiles && (
                    <i className="far fa-check" />
                  )}
                  {intl.formatMessage({ defaultMessage: 'Select all {files}' }, { files: filesTotal })}
                </DropdownItem>
              )}
              {(isSelectAllChecked || selectedAllFiles) && (
                <DropdownItem
                  onClick={() => {
                    unselectAllFiles();
                    selectAllFiles(false);
                  }}
                >
                  {intl.formatMessage({ defaultMessage: 'Unselect all' })}
                </DropdownItem>
              )}
            </DropdownMenu>
          </UncontrolledButtonDropdown>
        </>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  files: state.Files.files,
  filesTotal: state.Files.filesTotal,
  selectedFiles: state.Files.selectedFiles,
  selectedAllFiles: state.Files.selectedAllFiles,
  share: state.Shares.share,
});

const mapDispatchToProps = dispatch => ({
  selectVisibleFiles: (files) => {
    dispatch(setSelectedFiles(files));
  },
  selectAllFiles: (selectAllFiles) => {
    dispatch(setSelectedAllFiles(selectAllFiles));
  },
  unselectAllFiles: () => {
    dispatch(setSelectedFiles([]));
    dispatch(setSelectedAllFiles(false));
  },
});

FilesSelectAll.propTypes = {
  files: PropTypes.array.isRequired,
  filesTotal: PropTypes.number.isRequired,
  selectedFiles: PropTypes.array.isRequired,
  selectedAllFiles: PropTypes.bool.isRequired,
  share: PropTypes.object,
  selectVisibleFiles: PropTypes.func.isRequired,
  selectAllFiles: PropTypes.func.isRequired,
  unselectAllFiles: PropTypes.func.isRequired,
};

FilesSelectAll.defaultProps = {
  share: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(FilesSelectAll);
